<template>
  <div class="common-game-problem">
    <div class="header">
      <div class="header-left" @click="goBack">
        <van-icon name="arrow-left" v-if="showBack" />
      </div>
      <div class="header-title" @click="$router.push('/commonGameProblem/hot')">帮助中心</div>
      <div class="header-right" @click="showSidebar = true">
        <van-icon name="bars" />
        <span class="header-right-text">分类</span>
      </div>
    </div>
    <div class="search-wrap" @click="onSearchWrapClick">
      <van-search
        v-model="keyword"
        placeholder="搜索"
        shape="round"
        @search="handleSearch"
        @input="onInput"
      />
      <ul v-show="showSuggestions && suggestionList.length" class="suggestion-list">
        <li
          v-for="item in suggestionList"
          :key="item.id"
          class="suggestion-item"
          @click.stop="onSuggestionClick(item)"
          v-html="item.title"
        ></li>
      </ul>
    </div>
    <div class="content">
      <router-view />
    </div>
    <van-popup
      v-model="showSidebar"
      position="left"
      :style="{ width: '80%', height: '100%' }"
    >
      <div class="sidebar">
        <div class="sidebar-header">帮助中心分类</div>
        <div class="sidebar-list">
          <div v-for="menu in menus" :key="menu.id" class="menu-group">
            <div class="menu-group-title">{{ menu.name }}</div>
            <div
              v-for="child in menu.child"
              :key="child.id"
              class="menu-item"
              @click="onMenuClick(child)"
            >
              {{ child.name }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: '',
      showSidebar: false,
      menus: [],
      suggestionList: [],
      showSuggestions: false,
      debounceTimer: null,
    }
  },
  computed: {
    showBack() {
      return !['/commonGameProblem', '/commonGameProblem/hot'].includes(this.$route.path)
    },
  },
  created() {
    this.getTreeData()
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
    this.debounceTimer && clearTimeout(this.debounceTimer)
  },
  methods: {
    getTreeData() {
      this.$apis.gameProblemServer.treeCategory().then(res => {
        if (res.code === 0) {
          this.menus = res.data.dataList
        }
      })
    },
    onSearchWrapClick() {
      if (this.suggestionList.length) {
        this.showSuggestions = true
      }
    },
    onInput() {
      this.debounceTimer && clearTimeout(this.debounceTimer)
      if (!this.keyword) {
        this.suggestionList = []
        this.showSuggestions = false
        return
      }
      this.debounceTimer = setTimeout(() => {
        this.$apis.gameProblemServer.search({
          pageNo: 1,
          pageSize: 5,
          keyword: this.keyword,
        }).then(res => {
          if (res.code === 0) {
            this.suggestionList = res.data.dataList
            this.showSuggestions = true
          } else {
            this.showSuggestions = false
          }
        })
      }, 300)
    },
    handleSearch() {
      if (!this.keyword) return
      this.showSuggestions = false
      this.$router.push({ path: '/commonGameProblem/search', query: { keyword: this.keyword } })
    },
    onSuggestionClick(item) {
      this.showSuggestions = false
      this.keyword = item.title.replace(/<[^>]+>/g, '')
      this.$router.push({ path: '/commonGameProblem/faqInfo', query: { id: item.id } })
    },
    onDocClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showSuggestions = false
      }
    },
    onMenuClick(child) {
      this.showSidebar = false
      this.$router.push(`/commonGameProblem/faq/${child.id}`)
    },
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
.common-game-problem {
  min-height: 100vh;
  background: #f5f7fb;
}
.header {
  display: flex;
  align-items: center;
  height: 88px;
  padding: 0 30px;
  background: linear-gradient(135deg, #5A88FF 0%, #3D6BE5 100%);
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  &-left {
    width: 60px;
    font-size: 36px;
    color: #fff;
  }
  &-title {
    flex: 1;
    text-align: center;
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 2px;
  }
  &-right {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    background: rgba(255,255,255,0.2);
    border-radius: 30px;
    font-size: 28px;
    color: #fff;
    white-space: nowrap;
    transition: background 0.2s;
    &:active {
      background: rgba(255,255,255,0.35);
    }
    .van-icon-bars {
      font-size: 28px;
    }
    &-text {
      font-size: 24px;
    }
  }
}
.sidebar {
  height: 100%;
  overflow-y: auto;
  background: #fff;
  &-header {
    padding: 32px;
    font-size: 32px;
    font-weight: 700;
    color: #5A88FF;
    border-bottom: 2px solid #f0f2f5;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 36px;
      background: #5A88FF;
      border-radius: 0 4px 4px 0;
    }
  }
  &-list {
    padding: 16px 0;
  }
}
.menu-group {
  &-title {
    padding: 20px 32px;
    font-size: 26px;
    font-weight: 700;
    color: #333;
    background: #f5f7fb;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 28px;
      background: #5A88FF;
      border-radius: 0 3px 3px 0;
    }
  }
}
.menu-item {
  padding: 24px 32px 24px 50px;
  font-size: 28px;
  color: #444;
  border-bottom: 1px solid #f0f2f5;
  transition: background 0.2s;
  position: relative;
  &:active {
    background: #edf3ff;
    color: #5A88FF;
  }
  &::before {
    content: '';
    position: absolute;
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d0d5e0;
  }
}
.search-wrap {
  position: relative;
  background: linear-gradient(180deg, #3D6BE5 0%, #f5f7fb 100%);
  padding-bottom: 20px;
  z-index: 99;
}
.suggestion-list {
  position: absolute;
  top: 100%;
  left: 24px;
  right: 24px;
  background: #fff;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 8px 32px rgba(90,136,255,0.18);
  max-height: 500px;
  overflow-y: auto;
  list-style: none;
  margin: -12px 0 0;
  padding: 0;
}
.suggestion-item {
  padding: 24px 32px;
  font-size: 28px;
  color: #333;
  line-height: 1.4;
  border-bottom: 1px solid #f0f2f5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.2s;
  &:active {
    background: #edf3ff;
    color: #5A88FF;
  }
  &:last-child {
    border-bottom: none;
  }
}
/deep/ .van-search {
  padding: 16px 24px 0;
  background: transparent !important;
  .van-search__content {
    min-height: 80px;
    border-radius: 40px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(90,136,255,0.15);
  }
  .van-field__control {
    font-size: 28px;
    height: 80px;
    line-height: 80px;
  }
  .van-field__left-icon {
    font-size: 28px;
    line-height: 80px;
    .van-icon-search {
      color: #5A88FF;
    }
  }
}
</style>
